var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"component",on:{"click":_vm.showEmailModal}},'component',_vm.allPropsAndAttrs,false),_vm.$listeners),[_vm._v(_vm._s(['lg', 'xl'].includes(_vm.$mq) ? _vm.longText : _vm.shortText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }